export default __webpack_public_path__ + "static/media/klency.7d59b037.jpg";